import { createSelector } from '@reduxjs/toolkit';
import { IMessageProps } from 'Components/Core';
import { ChangeEventWithData } from 'Components/Core/types';
import { getMessagesForPath } from 'Components/Worksheets/Core/Helpers/messageHelpers';
import { RootState } from 'Data/Redux';
import { hasNonEmptyValue, hasValue } from 'Lib/Any';
import * as oPath from 'Lib/Object/Path/Immutable';
import { Selector } from 'react-redux';
import { AmddInjectedConsumerProps, AmddInjectedProviderData, AmddInjectedProviderProps } from '../types';

/***************
 * TODO: The provider props here is just basic change handling, very similar to other provider props.
 * Should think about how some of this can be made common.
 ****************/
// Only props you want to override on the consumer need to be returned.
export const getAssignedMaximumDryDensityProviderProps = (
  consumerProps: AmddInjectedConsumerProps,
  providerData: AmddInjectedProviderData
) => {
  let mutableConsumerProps = { ...consumerProps };
  let {
    name,
    onChange: consumerOnChange,
    value: consumerValue,
    messages: consumerMessages,
    //namePrefix,
    prefixName: consumerPrefixName,
  } = mutableConsumerProps;
  const { setValue, stateSelector } = providerData;

  let providerProps: AmddInjectedProviderProps = { hasInjectedProps: true };

  let prefixName = consumerPrefixName || ((n) => n);
  name = name && prefixName(name);

  if (name) {
    const valueSelector = createValueSelector(stateSelector, name, consumerValue);

    // Set value
    // if (name && consumerValue === undefined) {
    //   let value = data[name];

    //   if (value === undefined) value = null; // Remove undefined
    //   providerProps.value = value;
    // }

    // Set onChange
    if (name && !consumerOnChange) {
      const onchange = (evt: ChangeEventWithData) => {
        let value = evt.data?.value;

        if (name !== undefined && value !== undefined) {
          setValue({ name, value });
        }
      };

      providerProps.onChange = onchange;
    }

    providerProps.selectors = {
      ...providerProps.selectors,
      value: valueSelector,
      messages: createMessagesSelector(stateSelector, [name], consumerMessages),
    };
  }

  return providerProps;
};

const createValueSelector = (stateSelector: Selector<RootState, any>, name: string, consumerValue: any) =>
  createSelector(stateSelector, (state) => {
    if (hasNonEmptyValue(consumerValue)) return { value: consumerValue };

    const value = oPath.get(state, name);
    if (value && (value.uom || hasValue(value.value))) return { value: value.value }; // Extract value from unit model
    if (value === undefined) return { value: null }; // Remove undefined
    return { value };
  });

const createMessagesSelector = (
  stateSelector: Selector<RootState, any>,
  paths: string[],
  consumerMessages: IMessageProps[] | undefined = []
) =>
  createSelector(stateSelector, (state) => ({
    messages: paths
      .map((path) => getMessagesForPath(state, path))
      .flat(1)
      .concat(consumerMessages),
  }));
